import { IconButton, Tooltip } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { Run } from "../../../services/appsync/types";

export const LockForecastButtonComponent = ({
  mainRun,
  isLocked,
  onToggleLock,
  loading,
}: {
  mainRun: Run | null;
  isLocked: boolean;
  onToggleLock: () => void;
  loading: boolean;
}) => {
  return (
    <Tooltip
      title={
        isLocked
          ? "This run's forecast is locked as basis for future runs. Unlock to undo this and let future runs recalculate their own forecast."
          : "Lock this run's forecast for future runs. New runs will reuse this forecast as basis instead of recalculating it."
      }
    >
      <IconButton
        disabled={loading}
        onClick={onToggleLock}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mt: 1,
          mr: 1,
          color: isLocked ? "primary.main" : "grey.600",
        }}
      >
        {isLocked ? (
          <LockIcon sx={{ height: 25, color: "grey.600" }} />
        ) : (
          <LockOpenIcon sx={{ height: 25, color: "grey.600" }} />
        )}
      </IconButton>
    </Tooltip>
  );
};
